module.exports = __webpack_public_path__ + "static/media/pic-svg-2.b28532a8.svg";